// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-wrapper .svg-pointer {\n  z-index: 2;\n  position: absolute;\n  pointer-events: none;\n  right: 0;\n  top: 50%;\n  transform: translate(-50%, -50%) rotate(-90deg);\n  height: 20px;\n  width: 20px;\n}\n.select-wrapper .svg-pointer svg {\n    width: 15px;\n    height: 15px;\n}\n.select-wrapper .svg-pointer svg g.adjust {\n      transform: translate(8px, 4px);\n}\n", ""]);
// Exports
module.exports = exports;
